/**
 * Content - Holder of Form Columns
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Grid as SemanticGrid } from '@adc/ui-core'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const FormContent = ({ compact, centered, fill, children, className }) => (
  <SemanticGrid
    centered={centered}
    className={cx(
      'form-content',
      { compact, 'form-content--fill': fill },
      className
    )}
  >
    {children}
  </SemanticGrid>
)

FormContent.propTypes = {
  compact: PropTypes.bool,
  centered: PropTypes.bool,
  fill: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default FormContent
